// extracted by mini-css-extract-plugin
var _1 = "t2sX";
export { _1 as "title" }
